import { useEffect } from "react";
import { EdicaoLayout } from "src/components/projetos/edicao/layouts/EdicaoLayout";
import { ProjetoPersonalizado } from "src/components/projetos/personalizados";
import { appStore } from "src/framework/store/AppStore";

const PAGE_TITLE = "Edição projeto personalizado";

const ProjetoPersonalizadoEdicaoPage = () => {
  useEffect(() => {
    appStore.setPageTitle(PAGE_TITLE);
    return () => {
      appStore.setPageTitle("");
    }
  }, [])

  return (
    <EdicaoLayout>
      <div className="container">
        <div className="row">
          <div className="X12">
            <ProjetoPersonalizado />
          </div>
        </div>
      </div>
    </EdicaoLayout>
  );
};

export { ProjetoPersonalizadoEdicaoPage };
